import {ProjectTypeEnum} from '../constants/project-type';
import {Subject} from 'features/hylian-shield/types';

export const useCurrentSubject = (type?: ProjectTypeEnum): Subject => {
  return type === 'PETITS_PROJETS'
    ? 'studio-petits-projects'
    : 'studio-projects';
};
